import React from "react";
import Fallback from "../../components/Fallback";

const Contacts = React.lazy(() => import("./Contacts"));
export const ContactsScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Contacts {...props} />
  </React.Suspense>
);
